import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import getMemberPriorityTasks, {
    GetMemberPriorityTasksParams,
    MemberPriorityTasksResult,
} from './useMemberPriorityTasks.request';

export const MEMBER_PRIORITY_TASKS_QUERY_KEY = ['memberPriorityTasks'] as const;

/**
 * The server-ranked member task feed (GET /v2/members/tasks/feed/), returned as { items, totalItems }
 * so the carousel renders the same cards as useMemberTaskFeed and can show how many tasks remain beyond
 * the capped slice. Ranking and capping are server-owned — this hook does not re-sort. The carousel
 * consumes this; the Tasks page keeps useMemberTaskFeed.
 */
export default function useMemberPriorityTasks<TData = MemberPriorityTasksResult>(
    params: GetMemberPriorityTasksParams,
    options?: Omit<UseQueryOptions<MemberPriorityTasksResult, AxiosError, TData>, 'queryKey' | 'queryFn'>
) {
    return useQuery({
        queryKey: [...MEMBER_PRIORITY_TASKS_QUERY_KEY, params],
        queryFn: () => getMemberPriorityTasks(params),
        staleTime: 1000 * 60 * 5, // 5 minutes
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        ...options,
    });
}
